import React, { useEffect, useState } from "react"
import { Col, Row, Container, Card, Button } from "react-bootstrap"
import "./reset.css"
import signupimage from "../../img/signupimage.png"
import { FormInput, FormSelect } from "../form"
import { FaEye } from "react-icons/fa"
import { useForm } from "react-hook-form"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useResetPasswordMutation } from "../../services/authServices"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

interface roomComparisonProps {}
interface SignUpUser {
  password: string
  confirmedPassword: string
}
const schemaResolver = yupResolver(
  yup.object().shape({
    password: yup.string().required("Please fill in a password"),
    confirmedPassword: yup
      .string()
      .label("confirm password")
      .required()
      .oneOf([yup.ref("password"), ""], "Passwords must match"),
  }),
)
const Reset = (props: roomComparisonProps) => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const token = urlSearchParams.get("token")

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SignUpUser>({
    resolver: schemaResolver,
  })
  const navigate = useNavigate()
  const [show, setShow] = useState(true)

  const [resetPasswordApi, { data, error }] = useResetPasswordMutation()

  console.log("data", data)

  const onsubmit = async (value: any) => {
    const payload = {
      password: value.password,
      token: token,
    }

    resetPasswordApi(payload)
  }

  useEffect(() => {
    if (data?.message) {
      toast.success(data?.message)
      navigate("/")
    }
  }, [data])

  return (
    <>
      <div className="reset-form">
        <Container>
          <Row className="align-items-center">
            <Col md={5}>
              <div className="form-content">
                <div className="form-heading">
                  <h1>Reset Password</h1>
                </div>
                <div className="reset-form-form">
                  <div className="w-100 me-2 passwordinput position-relative">
                    <FormInput
                      name="password"
                      title="Password"
                      type={show ? "password" : "text"}
                      placeholder="********"
                      register={register}
                      className="password-wrapper"
                      errors={errors}
                    />
                    <div className="password-toggle-icon">
                      <FaEye />
                    </div>
                  </div>
                  <div className="w-100 passwordinput position-relative">
                    <FormInput
                      name="confirmedPassword"
                      title="Confirm Password"
                      type={show ? "password" : "text"}
                      placeholder="********"
                      register={register}
                      errors={errors}
                    />
                    <div
                      className="password-toggle-icon"
                      onClick={() => setShow(!show)}
                    >
                      <FaEye />
                    </div>
                  </div>
                </div>
                <div className="signup2 pt-1">
                  <Button
                    size="lg"
                    onClick={handleSubmit(onsubmit)}
                    className="my-3 w-100"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Col>
            <Col md={1}></Col>
            <Col md={6}>
              <div className="reset-image">
                <img src={signupimage} className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Reset
